// extracted by mini-css-extract-plugin
export default {"spacingToken":"H_7ulFjyYSz7GsZAtUPq","name":"J123a1AjXbwTFcARpHvf","separator":"zkBBzlFYzE2gAAFBeFAZ"};